/** @file Slot timelines of one animation: attachment placeholders, rgb/dark colors, alpha. */
import type { AnimationDoc, TimelineJson } from '@pose2d/format/types';
import { byCompiledIndex } from './byCompiledIndex';
import { curvedTimeline } from './curvedTimeline';
import { discreteTimeline } from './discreteTimeline';
import { hasKeys } from './hasKeys';
import { requireCompiledIndex } from './requireCompiledIndex';

/** Per keyed slot (compiled slot order): attachment, rgb, alpha, dark; rgb/dark curves in progress form (AR-4). */
export function slotTimelines(anim: AnimationDoc, fps: number, slotIndex: ReadonlyMap<string, number>, at: string): TimelineJson[] {
  const out: TimelineJson[] = [];
  for (const [id, tl] of byCompiledIndex(anim.slots, slotIndex)) {
    const slot = requireCompiledIndex(slotIndex, id, 'slot', `${at}.slots.${id}`);
    if (hasKeys(tl.attachment)) out.push({ k: 'attachment', slot, ...discreteTimeline(tl.attachment, fps, (v) => v) });
    if (hasKeys(tl.rgb)) out.push({ k: 'rgb', slot, ...curvedTimeline(tl.rgb, fps, null) });
    if (hasKeys(tl.alpha)) out.push({ k: 'alpha', slot, ...curvedTimeline(tl.alpha, fps, (v) => v) });
    if (hasKeys(tl.dark)) out.push({ k: 'dark', slot, ...curvedTimeline(tl.dark, fps, null) });
  }
  return out;
}
